import { render } from "./mped-cost-fact-view.vue?vue&type=template&id=2f5d16bd"
import script from "./mped-cost-fact-view.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-cost-fact-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/views/mped-cost-fact-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f5d16bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f5d16bd', __exports__)) {
    api.reload('2f5d16bd', __exports__)
  }
  
  module.hot.accept("./mped-cost-fact-view.vue?vue&type=template&id=2f5d16bd", () => {
    api.rerender('2f5d16bd', render)
  })

}


export default __exports__